<template>
	<div class="certificate-container none-select">
		<template v-if="listData.length">
			<!-- 标题 -->
			<div class="title">请选择您的证书</div>
			<!-- 证书 -->
			<div class="content link" v-for="(item, index) in listData" :key="index" @click="confirm(item)">
				<img src="~@/assets/certificate.png" />
				<div class="cert-name-wrap">
					<span class="certname">{{ item.certname }}</span>
					<span class="tags" v-if="item.datastatus == 1">资料未完善</span>
				</div>
			</div>
		</template>
		<div class="empty-view" v-else>
			<img src="@/assets/empty.png" class="notopen" />
			<span>您还未报名证书，快去报名证书吧！</span>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		mode: {
			type: String,
			default: 'exam'
		}
	},
	data() {
		return {
			listData: []
		};
	},
	created() {
		if (!this.$store.getters.getToken) {
			this.navToForbidden();
		} else {
			this.service2('client/exam/order', { type: this.mode }).then(res => {
				this.listData = res.data;
			});
		}
	},
	methods: {
		navToForbidden() {
			this.$router.replace({
				path: '/' + this.mode + '/login'
			});
		},
		confirm(item) {
			let order_id = item.order_id;
			if (this.mode === 'exam') {
				if (item.datastatus == 1) {
					if (this.$store.getters.isPc) {
						this.$alert('订单资料未完善，请先完善资料后进入考试。', '无法考试', {
							confirmButtonText: '确认'
						});
					} else {
						this.$dialog.alert({
							title: '无法考试',
							message: '订单资料未完善，请先完善资料后进入考试。'
						});
					}
				} else if (item.is_exam == 1) {
					// 考试模式跳转到提示页面
					this.$router.push({
						name: this.mode,
						params: {
							name: 'guide'
						},
						query: {
							id: order_id
						}
					});
				} else {
					this.$router.push({
						name: this.mode,
						params: {
							name: 'tips'
						},
						query: {
							orderid: order_id
						}
					});
				}
			} else {
				// 练习模式直接跳转至问题详情
				this.$router.push({
					name: this.mode,
					params: {
						name: 'list'
					},
					query: {
						id: order_id
					}
				});
			}
		}
	}
};
</script>

<style lang="less" scoped>
@import './Choice.less';
</style>
